export enum jumpType {
  'BOOT' = 'BOOT',
  'SAME_TYPE' = 'SAME_TYPE',
  'ANY_TYPE' = 'ANY_TYPE',
  'FOCUS' = 'FOCUS',
}
